import { render, staticRenderFns } from "./SelectRiskAssessmentDbButton.vue?vue&type=template&id=7cbd59b2&scoped=true"
import script from "./SelectRiskAssessmentDbButton.vue?vue&type=script&lang=js"
export * from "./SelectRiskAssessmentDbButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbd59b2",
  null
  
)

export default component.exports